export enum EDashletAcitivity {
  DELETE = 'DELETE',
  POINT_COPY = 'POINT_COPY',
  POINT_MOVE = 'POINT_MOVE',
  NEW_DOCUMENT = 'NEW_DOCUMENT',
  UPDATE_CHANGES = 'UPDATE_CHANGES',
}
